import { NgIf } from "@angular/common";
import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnInit } from "@angular/core";

import { LinkModel } from "../../shared-library/delivery-api/models/link.model";

@Component({
    selector: "a[pcg-ng-umbraco-link]",
    templateUrl: "umbraco-link.component.html",
    imports: [
        NgIf
    ],
    standalone: true
})
export class UmbracoLinkComponent implements OnInit, AfterViewInit {
    @Input() public link: Array<LinkModel>;

    @HostBinding("attr.href") public href: string;

    protected internalLink: LinkModel;
    protected isExplicitContent: boolean = true;

    public constructor(
        private elementRef: ElementRef
    ) {
    }

    public ngOnInit(): void {
        if (!this.link || this.link.length !== 1) {
            return;
        }

        this.internalLink = this.link[0];

        if (this.internalLink.linkType === "Content") {
            if (!this.internalLink.route?.path) {
                return;
            }

            this.href = this.internalLink.route.path + (this.internalLink.queryString ?? "");
            return;
        }

        this.href = this.internalLink.url;
    }

    public ngAfterViewInit(): void {
        const nativeElement = this.elementRef.nativeElement as HTMLElement;

        if (!nativeElement.innerText) {
            setTimeout(() => {
                this.isExplicitContent = false;
            }, 0);
        }
    }
}
